import React from "react";
import theme from "app/Theme/Theme";
import Svg, {
  Circle,
  Defs,
  LinearGradient,
  Path,
  Stop,
} from "react-native-svg";
import normalize from "app/utils/normalize";

const CoachingNotification = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.white"],
  ...props
}) => (
  <Svg
    width={height}
    height={width}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Circle cx={12} cy={12} r={12} fill="url(#CoachingNotification1)" />
    <Path
      d="M10.25 11.417a2.333 2.333 0 1 0 0-4.667 2.333 2.333 0 0 0 0 4.667ZM15.208 14.333a1.458 1.458 0 1 0 0-2.917 1.458 1.458 0 0 0 0 2.917ZM15.717 14.958c.509.083.976.29 1.344.592.257.201.772.791.772 1.536 0 .082-.04.16-.11.219a.418.418 0 0 1-.265.09h-4.5a.418.418 0 0 1-.265-.09.286.286 0 0 1-.11-.22c.001-.428.155-.848.443-1.204a2.581 2.581 0 0 1 1.177-.799 3.136 3.136 0 0 1 1.514-.124Z"
      fill={color}
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.132 13.774a4.083 4.083 0 0 0-6.965 2.887.583.583 0 0 0 .583.583h5.254c.03-.552.215-1.088.538-1.55a3.168 3.168 0 0 1 1.244-1.043 3.834 3.834 0 0 0-.654-.877Z"
      fill={color}
    />
    <Defs>
      <LinearGradient
        id="CoachingNotification1"
        x1={12}
        y1={-3}
        x2={12}
        y2={26.5}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset="0" stopColor="#B942FF" />
        <Stop offset="1" stopColor="#C602BE" />
      </LinearGradient>
    </Defs>
  </Svg>
);

export default CoachingNotification;
